<template>
    <div>
        <tabs>
            <tab name="Yurt Bilgileri">
                <!-- Yurt Bilgileri -->
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Yurt Bilgileri</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="is_active">Durumu</label>
                                            <select v-model="is_active" class="form-control custom-input">
                                                <option value="1">Aktif</option>
                                                <option value="0">Pasif</option>
                                                <option value="3">Arşivlenmiş</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="logo">Logo</label>
                                            <input type="file" @change="onLogo" class="form-control custom-input">
                                            <div v-if="display_logo" class="image_content">
                                                <img :src="display_logo" alt class="display-img">
                                                <button
                                                        type="button"
                                                        class="btn btn-danger trash-btn"
                                                        @click="destroyLogo()"
                                                >
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="cover">Kapak Fotoğrafı</label>
                                            <input type="file" @change="onCover" class="form-control custom-input">
                                            <div v-if="display_cover" class="image_content">
                                                <img :src="display_cover" alt class="display-img">
                                                <button
                                                        type="button"
                                                        class="btn btn-danger trash-btn"
                                                        @click="destroyCover()"
                                                >
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="user_info">Üye Bilgisi</label>
                                            <!--                      <select v-model="user_info" class="form-control custom-input">-->
                                            <!--                        <option value hidden selected disabled>Seçiniz...</option>-->
                                            <!--                        <option-->
                                            <!--                          v-for="user in users"-->
                                            <!--                          :key="user.id"-->
                                            <!--                          :value="user.id"-->
                                            <!--                        >{{ user.first_name }} {{ user.last_name }}</option>-->
                                            <!--                      </select>-->
                                            <model-select :options="users"
                                                          v-model="user_info"
                                                          placeholder="Üye Bilgisi"
                                                          class="form-control custom-input">
                                            </model-select>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="dorm_type">Yurt Tipi</label>
                                            <select v-model="dorm_type" class="form-control custom-input">
                                                <option value selected disabled hidden>Seçiniz...</option>
                                                <option value="1">Erkek Öğrenci Yurdu</option>
                                                <option value="2">Kız Öğrenci Yurdu</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="city">İl</label>
                                            <select
                                                    v-model="city"
                                                    class="form-control custom-input"
                                                    @change="getDistricts(city)"
                                            >
                                                <option
                                                        v-for="city in cities"
                                                        :key="city.id"
                                                        :value="city.id"
                                                >{{ city.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="district">İlçe</label>
                                            <select v-model="district" class="form-control custom-input">
                                                <option
                                                        v-for="district in districts"
                                                        :key="district.id"
                                                        :selected="district_selected"
                                                        :value="district.id"
                                                >{{ district.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="name">Yurt Adı</label>
                                            <input
                                                    type="text"
                                                    v-model="name"
                                                    class="form-control custom-input"
                                                    placeholder="Yurt Adı Girin"
                                            >
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="slug">SEF Link</label>
                                            <input
                                                    type="text"
                                                    v-model="slug"
                                                    class="form-control custom-input"
                                                    placeholder="Slug"
                                            >
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="center_name">Merkez Yurt Adı</label>
                                            <input type="text" class="form-control custom-input" v-model="center_name">
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="center_slug">Merkez Yurt SLUG</label>
                                            <input type="text" class="form-control custom-input" v-model="center_slug">
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Meta">
                <!-- Yurt Not -->
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Meta Etiketler</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="keywords">Keywords</label>
                                            <textarea v-model="keywords" class="form-control custom-input"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="description">Description</label>
                                            <textarea v-model="description"
                                                      class="form-control custom-input"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="İçerik Yazısı">
                <!-- Yurt İçerik Yazısı -->
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>İçerik (Ziyaretçilerin göreceği yurt genel açıklaması)</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="content">İçerik (TR)</label>
                                            <vue-editor v-model="content" class="editor"></vue-editor>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="content">İçerik (EN)</label>
                                            <vue-editor v-model="content_en" class="editor"></vue-editor>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Genel Bilgiler">
                <!-- Yurt Genel Bilgiler (Avantajlar, Etkinlikler, Ulaşım vs) -->
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Genel Bilgiler</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="facilities">İmkanlar</label>
                                            <vue-editor v-model="facilities" class="editor"></vue-editor>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="advantages">Avantajlar</label>
                                            <vue-editor v-model="advantages" class="editor"></vue-editor>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="events">Etkinlikler</label>
                                            <vue-editor v-model="events" class="editor"></vue-editor>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="transportation">Ulaşım</label>
                                            <vue-editor v-model="transportation" class="editor"></vue-editor>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="other">Diğer</label>
                                            <vue-editor v-model="other" class="editor"></vue-editor>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="İletişim Bilgileri">
                <!-- Yurt İletişim Bilgileri -->
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Yurt İletişim Bilgileri</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="member">Yurt Yetkilisi</label>
                                            <input
                                                    type="text"
                                                    v-model="member"
                                                    class="form-control custom-input"
                                                    placeholder="Yurt Yetkilisi"
                                            >
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="phone">Sabit Telefon</label>
                                            <input
                                                    type="text"
                                                    v-model="phone"
                                                    placeholder="02xxxxxxxxx"
                                                    class="form-control custom-input"
                                            >
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="mobile_phone">Mobil İletişim Telefon</label>
                                            <input
                                                    type="text"
                                                    v-model="mobile_phone"
                                                    placeholder="05xxxxxxxxx"
                                                    class="form-control custom-input"
                                            >
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="message_phone">Whatsapp Mesaj Telefonu</label>
                                            <input
                                                    type="text"
                                                    v-model="message_phone"
                                                    placeholder="05xxxxxxxxx"
                                                    class="form-control custom-input"
                                            >
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="fax">Fax</label>
                                            <input
                                                    type="text"
                                                    v-model="fax"
                                                    placeholder="02xxxxxxxxx"
                                                    class="form-control custom-input"
                                            >
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="email">E-mail</label>
                                            <input
                                                    type="text"
                                                    v-model="email"
                                                    placeholder="example@mail.com"
                                                    class="form-control custom-input"
                                            >
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="web">Web Adresi</label>
                                            <input
                                                    type="text"
                                                    v-model="web"
                                                    placeholder="https://"
                                                    class="form-control custom-input"
                                            >
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="address">Adres</label>
                                            <textarea
                                                    v-model="address"
                                                    class="form-control custom-input"
                                                    cols="30"
                                                    rows="10"
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Harita">
                <!-- Yurt Haritası -->
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Harita Bilgileri</h3>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="lat">Koordinat (x)</label>
                                        <input type="text" v-model="lat" class="form-control custom-input">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="lng">Koordinat (x)</label>
                                        <input type="text" v-model="lng" class="form-control custom-input">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Not">
                <!-- Yurt Not -->
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Yurt Notu</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="note">Not</label>
                                            <vue-editor v-model="note" class="editor"></vue-editor>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Lokasyon">
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Hangi Üniversitelere Yakın?</h3>
                                </div>
                                <div class="form-group">
                                    <label for>Hangi Üniversitelere Yakın?</label>
                                    <multiselect
                                            v-model="university"
                                            tag-placeholder="Üniversite Ekle"
                                            placeholder="Üniversite Ara"
                                            label="name"
                                            :close-on-select="false"
                                            :clear-on-select="false"
                                            :custom-label="nameWithUniversity"
                                            track-by="id"
                                            :options="universities"
                                            :multiple="true"
                                            :taggable="true"
                                            @tag="addTag"
                                    ></multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Özellikler">
                <!-- Yurt Özellikleri -->
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Yurt Özellikleri</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="capacity">Yurt Kapasitesi</label>
                                            <input
                                                    type="text"
                                                    v-model="capacity"
                                                    class="form-control custom-input"
                                                    placeholder="örn: 350"
                                            >
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="meal">Öğün</label>
                                            <input
                                                    type="text"
                                                    v-model="meal"
                                                    class="form-control custom-input"
                                                    placeholder="örn: 1"
                                            >
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="is_wifi">Wi-Fi</label>
                                            <select class="form-control custom-input" v-model="is_wifi">
                                                <option value="1">Var</option>
                                                <option value="0">Yok</option>
                                            </select>
                                        </div>
                                    </div>

                                    <hr>

                                    <div
                                            class="properties-d"
                                            v-for="propertyCategory in properties"
                                            :key="propertyCategory.id"
                                    >
                                        <div class="col-md-12">
                                            <h3>{{ propertyCategory.title }}</h3>
                                            <div class="line"></div>
                                        </div>
                                        <div
                                                class="col-md-3"
                                                v-for="property in propertyCategory.properties"
                                                :key="property.id"
                                        >
                                            <label class="properties-cont" @click="checkClick">
                                                {{ property.title }}
                                                <input
                                                        type="checkbox"
                                                        v-model="props"
                                                        :key="property.id"
                                                        :value="property.id"
                                                >
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Resim Galerisi">
                <!-- Yurt Resim Galerisi -->
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Resim Galerisi</h3>
                                </div>
                                <div class="row">
                                    <div class="form-group">
                                        <label for="images">
                                            Resim Ekle
                                            <small>(Birden fazla seçim yapılabilir)</small>
                                        </label>
                                        <input
                                                type="file"
                                                class="form-control custom-input"
                                                ref="images"
                                                multiple
                                                @change="handleImages"
                                        >
                                    </div>
                                    <draggable v-model="images">
                                        <transition-group>
                                            <div class="col-md-4 galleryImage" v-for="image in images" :key="image.id">
                                                <img :src="image.filename" alt class="img-responsive">
                                                <button class="btn btn-danger trash-btn" @click="destroyImage(image)">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </div>
                                        </transition-group>
                                    </draggable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
            <tab name="Multimedya">
                <!-- Yurt Video -->
                <div class="row">
                    <div class="col-md-12">
                        <div class="widget">
                            <div class="form-elements-sec">
                                <div class="widget-title">
                                    <h3>Multimedya</h3>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="video_type">Video Tipi</label>
                                            <select v-model="video_type" class="form-control custom-input">
                                                <option value="youtube">YouTube</option>
                                                <option value="vimeo">Vimeo</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="video_status">Video Aktif / Pasif</label>
                                            <select id="video_status" v-model="video_status" class="form-control custom-input">
                                                <option value="" disabled selected hidden>Seçiniz...</option>
                                                <option value="1">Aktif</option>
                                                <option value="0">Pasif</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="video_url">Video URL <small>* (ID)</small></label>
                                            <textarea v-model="video_url" rows="5" class="form-control custom-input" placeholder="v={id}"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="virtual_tour">Sanal Tur</label>
                                            <input type="text" class="form-control custom-input" v-model="virtual_tour">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </tab>
        </tabs>
        <div class="row">
            <div class="col-md-12">
                <div class="widget">
                    <div class="form-elements-sec">
                        <error :errors="validationErrors" v-if="validationErrors"></error>
                        <div style="width: 100%;" class="text-center">
                            <button class="btn btn-edit" @click="add()" :disabled="loading">Kaydet</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import {VueEditor} from "vue2-editor";
    import Multiselect from "vue-multiselect";
    import draggable from "vuedraggable";
    import Error from "@/components/layouts/Error";
    import {ModelSelect} from 'vue-search-select'

    export default {
        components: {VueEditor, Multiselect, draggable, Error, ModelSelect},
        data() {
            return {
                loading: false,
                validationErrors: "",
                ids: [],
                customToolbar: [
                    ["bold", "italic", "underline"],
                    [{list: "ordered"}, {list: "bullet"}]
                ],
                // Yurt Bilgileri
                id: this.$route.params.id,
                is_active: null,
                logo: "",
                cover: "",
                display_logo: "",
                display_cover: "",
                name: "",
                city: "",
                keywords: "",
                description: "",
                district: "",
                district_selected: "",
                user_info: "",
                dorm_type: "",
                member: "",
                capacity: "",
                is_wifi: "",
                meal: "",
                users: [],
                cities: [],
                dorm_types: [],
                districts: [],
                isCity: false,
                center_name: '',
                // Yurt içerik yazısı
                content: "",
                content_en: "",
                // Yurt Genel Bilgiler (Avantajlar, Etkinlikler, Ulaşım vs)
                facilities: "",
                advantages: "",
                events: "",
                transportation: "",
                other: "",
                // Yurt iletişim bilgileri
                phone: "",
                mobile_phone: "",
                message_phone: "",
                fax: "",
                email: "",
                web: "",
                address: "",
                // Yurt Haritası
                lat: "",
                lng: "",
                // Not
                note: "",
                // Yurt Özellikleri
                properties: [],
                props: [],
                virtual_tour: '',
                // Lokasyon
                faculties: [],
                university: [],
                universities: [],
                // Yurt Resim Galerisi
                images: [],
                // Video
                video_type: 'youtube',
                video_url: '',
                video_status: '',
            };
        },

        mounted() {
            this.getData();
        },
        methods: {
            nameWithUniversity({name, university}) {
                if (university) {
                    return `${name} — (${university.name})`;
                }
                return name;
            },
            checkClick() {
                // console.log(this.properties);
            },
            onLogo(event) {
                this.logo = event.target.files[0];
                // console.log(this.logo);
            },
            onCover(event) {
                this.cover = event.target.files[0];
                // console.log(this.cover);
            },
            handleImages(e) {
                let selectedFlies = e.target.files;
                if (!selectedFlies.length) {
                    return false;
                }
                for (let i = 0; i < selectedFlies.length; i++) {
                    this.images.push(selectedFlies[i]);
                }
                // console.log(this.images);
            },
            getData() {
                this.axios.get("dorms/create").then(response => {
                    this.users = response.data.users;
                    this.cities = response.data.cities;
                    this.properties = response.data.properties;
                    this.universities = response.data.universities;
                    // console.log(this.universities);
                });
            },
            getDistricts() {
                this.axios.get("districts/" + this.city).then(response => {
                    this.districts = response.data;
                });
            },
            add() {
                this.loading = true;
                this.validationErrors = "";
                this.$Progress.start();
                var data = {
                    // Yurt Bilgileri
                    user_id: this.user_info || '',
                    type_id: this.dorm_type || '',
                    city_id: this.city || '',
                    district_id: this.district || '',
                    is_active: this.is_active || '',
                    name: this.name || '',
                    slug: this.slug || '',
                    keywords: this.keywords || '',
                    description: this.description || '',
                    member: this.member || '',
                    capacity: this.capacity || '',
                    is_wifi: this.is_wifi || '',
                    meal: this.meal || '',
                    center_name: this.center_name || '',
                    center_slug: this.center_slug || '',
                    virtual_tour: this.virtual_tour || '',
                    // özellikler
                    properties: this.properties,
                    // İçerik
                    content: this.content || '',
                    content_en: this.content_en || '',
                    // Genel Bilgiler
                    facilities: this.facilities,
                    advantages: this.advantages || '',
                    events: this.events || '',
                    transportation: this.transportation || '',
                    other: this.other || '',
                    // İletişim Bilgileri
                    phone: this.phone || '',
                    mobile_phone: this.mobile_phone || '',
                    message_phone: this.message_phone || '',
                    fax: this.fax || '',
                    email: this.email || '',
                    web: this.web || '',
                    address: this.address || '',
                    // Harita Bilgileri
                    lat: this.lat,
                    lng: this.lng,
                    // Not
                    note: this.note || '',
                    // Video
                    video_type: this.video_type || '',
                    video_url: this.video_url || '',
                    video_status: this.video_status || '',
                };
                const formData = new FormData();
                formData.append("logo", this.logo);
                const config = {headers: {"Content-Type": "multipart/form-data"}};

                for (let i = 0; i < this.images.length; i++) {
                    formData.append("images[]", this.images[i]);
                }
                for (let i = 0; i < this.props.length; i++) {
                    formData.append("props[]", this.props[i]);
                }
                for (let i = 0; i < this.university.length; i++) {
                    formData.append("faculties[]", this.university[i].id);
                }
                if (this.cover) {
                    formData.append("cover", this.cover);
                }
                if (this.logo) {
                    formData.append("logo", this.logo);
                }
                Object.keys(data).map(e => {
                    formData.append(e, data[e]);
                });
                this.axios.post("dorms", formData, config)
                    .then(response => {
                        if (response.status == 201) {
                            this.$router.push({
                                name: "dorms.update",
                                params: {id: response.data.id}
                            });
                        }
                    }).catch(error => {
                    this.$Progress.finish();
                    this.loading = false;
                    this.$swal.fire({
                        position: 'top-end',
                        type: 'error',
                        title: 'İşlem başarısız!',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    if (error.response.status == 422) {
                        this.validationErrors = error.response.data.errors;
                    } else if (error.response.status == 500) {
                        this.validationErrors = {message: ['Bilinmeyen bir hata oluştu. Lütfen servis sağlayıcınıza başvurun veya daha sonra tekrar deneyiniz.!']};
                    }
                });
            },
            updateCoordinates(location) {
                this.lat = location.latLng.lat();
                this.lng = location.latLng.lng();
            },
            addTag(newTag) {
                const tag = {
                    name: newTag,
                    id: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
                };
                this.universities.push(tag);
                this.university.push(tag.id);
            }
        },

        computed: {
            slug() {
                return window.Slug(this.name);
            },
            center_slug: {
                get() {
                    return this.center_name && window.Slug(this.center_name.toLowerCase());
                },
                set(center_name) {
                    return center_name && window.Slug(center_name);
                }
            }
        }
    };
</script>

<style scoped>
    @import url(https://cdnjs.cloudflare.com/ajax/libs/select2/4.0.6-rc.0/css/select2.min.css);

    .properties-cont {
        display: block;
        position: relative;
        padding-left: 35px;
        margin-bottom: 30px;
        cursor: pointer;
        font-size: 14px;
        font-weight: normal;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default checkbox */
    .properties-cont input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 25px;
        width: 25px;
        background-color: #eee;
    }

    /* On mouse-over, add a grey background color */
    .properties-cont:hover input ~ .checkmark {
        background-color: #ccc;
    }

    /* When the checkbox is checked, add a blue background */
    .properties-cont input:checked ~ .checkmark {
        background-color: #2196f3;
    }

    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    .line {
        width: 100%;
        height: 1px;
        background-color: #666;
        margin-bottom: 15px;
    }

    /* Show the checkmark when checked */
    .properties-cont input:checked ~ .checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .properties-cont .checkmark:after {
        left: 10px;
        top: 7px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    .editor {
        height: 350px;
        margin-bottom: 80px;
    }

    .h-500 {
        height: 500px;
    }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
